import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7362 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7362 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12ZM15.207 8.79297C14.8165 8.40244 14.1835 8.40244 13.793 8.79297L12 10.5859L10.207 8.79297C9.81651 8.40244 9.18349 8.40244 8.79297 8.79297C8.40244 9.18349 8.40244 9.81651 8.79297 10.207L10.5859 12L8.79297 13.793C8.40244 14.1835 8.40244 14.8165 8.79297 15.207C9.18349 15.5976 9.81651 15.5976 10.207 15.207L12 13.4141L13.793 15.207C14.1835 15.5976 14.8165 15.5976 15.207 15.207C15.5976 14.8165 15.5976 14.1835 15.207 13.793L13.4141 12L15.207 10.207C15.5976 9.81651 15.5976 9.18349 15.207 8.79297Z",
		fill: "currentColor"
	})
});
export default SvgCloseFilled;
